//src/API/Api.js

export const baseURL = `https://number1one.publicvm.com/api`


// User Management 
export const REGISTER = `${baseURL}/auth/register/super-admin/`

export const SEND_OTP = `${baseURL}/auth/send-otp/`;

export const LOGIN = `${baseURL}/auth/login/`

export const TOKEN_REFRESH = `${baseURL}/token/refresh/`

export const CONFIRM_OTP = `${baseURL}/auth/confirm-otp/`

export const RESET_PASSWORD = `${baseURL}/auth/reset-password/`

export const LOGOUT = `${baseURL}/auth/logout/`

export const USER_PROFILE = `${baseURL}/auth/profile/`;

export const UPDATE_USER_PROFILE = `${baseURL}/auth/profile/`;

export const CHANGE_PASSWORD = `${baseURL}/auth/change-password/`;

export const LIST_USERS = `${baseURL}/auth/admin/users/`;

export const ACTIVATE_USER = (userId) => `${baseURL}/auth/admin/users/${userId}/activate/`;

export const DISABLE_USER = (userId) => `${baseURL}/auth/admin/users/${userId}/disable/`;

export const USER_REFERRAL = (userId) => `${baseURL}/auth/admin/users/${userId}/referral/`;

export const REMOVE_USER_REFERRAL = (userId) => `${baseURL}/auth/admin/users/${userId}/referral/remove/`;

export const SET_WHOLESALE_USER = (userId) => `${baseURL}/auth/admin/users/${userId}/wholesale/`;

// Wallet Operations 

export const WALLET_TRANSACTIONS = `${baseURL}/wallets/transactions/`;

export const WALLET_TRANSFER = `${baseURL}/wallets/transfer/`;

export const WALLET_BALANCE = `${baseURL}/wallets/balance/`;

export const ABILI_BALANCE = `${baseURL}/telecom/admin/abili-balance/`;

// MTN Operation 

export const MTN_BULK = `${baseURL}/telecom/mtn/bulk-recharge/`;

export const MTN_RETAIL = `${baseURL}/telecom/mtn/retail-recharge/`;

export const MTN_BULK_BILL = `${baseURL}/telecom/mtn/bulk-bill-payment/`;

export const MTN_ELECTRONIC_BALANCE = `${baseURL}/telecom/mtn/electronic-balance-recharge/`;

export const MTN_CASH = `${baseURL}/telecom/mtn/cash-recharge/`;

export const MTN_RETAIL_BILL = `${baseURL}/telecom/mtn/retail-bill-payment/`;



// Syriatel Operations 

export const SYRIATEL_RETAIL_RECHARGE = `${baseURL}/telecom/syriatel/retail-recharge/`;

export const SYRIATEL_BULK_RECHARGE = `${baseURL}/telecom/syriatel/bulk-recharge/`;

export const SYRIATEL_CASH_RECHARGE = `${baseURL}/telecom/syriatel/cash-recharge/`;

export const SYRIATEL_BILL_PAYMENT = `${baseURL}/telecom/syriatel/bill-payment/`;

export const SYRIATEL_ELECTRONIC_BALANCE_RECHARGE = `${baseURL}/telecom/syriatel/electronic-balance-recharge/`;

export const ADMIN_SYRIATEL_TRANSACTIONS = `${baseURL}/reports/admin/syriatel-transactions/`;
export const RETRY_SYRIATEL_TRANSACTION = (id) => `${baseURL}/telecom/admin/syriatel/transactions/${id}/retry/`;

export const ADMIN_MTN_TRANSACTIONS = `${baseURL}/reports/admin/mtn-transactions/`;
export const RETRY_MTN_TRANSACTION = (id) => `${baseURL}/telecom/admin/mtn/transactions/${id}/retry/`;

export const ADMIN_ALL_TRANSACTIONS = `${baseURL}/reports/admin/all-transactions/`;

export const ADMIN_WALLETS = `${baseURL}/reports/admin/wallets/`;
export const ADMIN_TOTAL_BALANCES = `${baseURL}/reports/admin/total-balances/`;

// Telecom Transactions

export const SERVICES_TRANSACTIONS = `${baseURL}/telecom/transactions/`;


// Reports

export const REPORTS_DASHBOARD = `${baseURL}/reports/dashboard/`;

export const REPORTS_QUICK_STATS = `${baseURL}/reports/quick-stats/`;

export const REPORTS_TRENDING = `${baseURL}/reports/trending/`;

export const REPORTS_ANALYTICS_PERFORMANCE = `${baseURL}/reports/analytics/performance/`;

//////////////////////////////

export const REPORTS_ANALYTICS_FINANCIAL = `${baseURL}/reports/analytics/financial/`;

export const REPORTS_ANALYTICS_USERS = `${baseURL}/reports/analytics/users/`;

export const REPORTS_HISTORY = `${baseURL}/reports/history/`;

export const USER_FINANCIAL_STATEMENT = (userId) => `${baseURL}/reports/financial-statement/user/${userId}/`;

///////////////////////////////////

export const ACTIVE_SERVICES = `${baseURL}/telecom/active-services/`;

export const API_CONNECTIONS = `${baseURL}/telecom/admin/api-connections/`;

export const SERVICE_COMMISSIONS = `${baseURL}/telecom/admin/service-commissions/`;

export const API_CONNECTION_UPDATE = (id) => `${baseURL}/telecom/admin/connection/${id}/`;

export const SERVICE_COMMISSION_UPDATE = (id) => `${baseURL}/telecom/admin/commission/${id}/`;

// Maintenance Mode
export const MAINTENANCE_STATUS = `${baseURL}/telecom/maintenance-status/`;
export const MAINTENANCE_MODE = `${baseURL}/telecom/admin/maintenance-mode/`;

// export const USER_FINANCIAL_STATEMENT = (userId) => `${baseURL}/reports/financial-statement/user/${userId}/`;

// export const SET_WHOLESALE_USER = (userId) => `${baseURL}/auth/admin/users/${userId}/wholesale/`;




// export const baseURL = `http://127.0.0.1:8000/api`
